<template>
  <div id="app" >
    <router-view class="router"></router-view>
  </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            
        };
    },
    created(){
        this.$router.push({path:'/companyweb'})
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue